export default {
  'pl': {
    'DRAFT': 'Oferta',
    'CUSTOMER_ORDER': 'Zamówienie klienta',
    'INQUIRY': 'Zapytanie ofertowe',
    'NEW': 'Nowa oferta',
    'SENT_TO_CUSTOMER': 'Wysłana do klienta',
    'TO_COLLECT': 'Do zebrania',
    'WAITING_PURCHASE_PRODUCTS': 'Oczekuje na produkty',
    'ORDER': 'Zamówienie',
    'IN_PRODUCTION': 'W produkcji',
    'TO_CHECK': 'Do sprawdzenia na magazynie',
    'PREPARATION_FOR_SHIPPING': 'Gotowe do wysyłki',
    'WAITING_FOR_SHIPPING': 'Czeka na wysyłkę',
    'SENT': 'Wysłane',
    'PENDING_PAYMENT': 'Oczekuje na płatność',
    'ENDED': 'Zakończone',
    'TO_DELETE': 'Do usunięcia',
    'DELETED': 'Usunięte',
    'OFFER_CLOSED': 'Nieaktualna oferta',
    'REQUEST_INVOICE': 'Żądanie wystawienia faktury',
    'REQUEST_ADVANCE_INVOICE': 'Żądanie wystawienia faktury zaliczkowej'
  },
  'en': {
    'DRAFT': 'Draft',
    'CUSTOMER_ORDER': 'Customer order',
    'INQUIRY': 'Inquiry',
    'NEW': 'New offer',
    'SENT_TO_CUSTOMER': 'Sent to customer',
    'TO_COLLECT': 'To collect',
    'WAITING_PURCHASE_PRODUCTS': 'Waiting purchase products',
    'ORDER': 'Order',
    'IN_PRODUCTION': 'In production',
    'TO_CHECK': 'To check in warehouse',
    'PREPARATION_FOR_SHIPPING': 'Preparation for shipping',
    'WAITING_FOR_SHIPPING': 'Waiting for shipping',
    'SENT': 'Sent',
    'PENDING_PAYMENT': 'Pending payment',
    'ENDED': 'Ended',
    'TO_DELETE': 'To delete',
    'DELETED': 'Deleted',
    'OFFER_CLOSED': 'Offer closed',
    'REQUEST_INVOICE': 'Request for an invoice',
    'REQUEST_ADVANCE_INVOICE': 'Request for an advance invoice'
  }
};
